import { FilterObject } from './filter-object';

export class BooleanFilter extends FilterObject<any> {

  public filter(itemToFiltre: any): boolean {
    return this.doFilter(itemToFiltre, this.field, this.values);
  }

  public doFilter(itemToFiltre: any, field: any, value: any): boolean {
   if (value) {
      return itemToFiltre[field] == value;
    }
    return true;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/filter/filters/boolean.filter.ts